import React from "react";
import styled from "styled-components";

// Shared by ProductDrawer and ProductDescriptionModal: a white fade at the
// bottom of a scroll container that hides once its end sentinel is visible.

export const GradientText = styled.div<{ $hidden?: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFF 100%);
  transform: translateY(${(props) => (props.$hidden ? "100%" : "0")});
`;

export const ScrollEndSentinel = styled.div`
  height: 1px;
`;

// Stores a DOM node in state so effects re-run when it mounts/unmounts.
// The setter is stable, so it can be passed straight to `ref`.
export function useElementRef<T extends HTMLElement>() {
  const [node, setNode] = React.useState<T | null>(null);
  return [node, setNode] as const;
}

// Whether `target` is at least partly visible inside the scroll container `root`.
export function useIsVisibleIn(
  root: HTMLElement | null,
  target: HTMLElement | null,
) {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (!root || !target) {
      setIsVisible(false);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { root },
    );
    observer.observe(target);

    return () => observer.disconnect();
  }, [root, target]);

  return isVisible;
}
